import {
    executeJsonGetMethod,
    executeJsonPostMethod,
    executePostMethod,
    executePutMethod
} from '../api/rest/restApiUtils'

/**
 * Получение статискики по url
 * @param {string} path - путь до статискики с query переменными
 * @method getStatistic
 * @return {Response} Fetch Response
 */
export function getStatistic(path: string) {
    return executeJsonGetMethod(path).then((resp) => {
        return Promise.resolve(resp.data)
    })
}

/**
 * Сохранение статистики по тесту
 * @param {object} sendingData - объект статистики
 * @method saveUserTestStatistic
 * @return {Response} Fetch Response
 */
export function saveUserTestStatistic(sendingData: any) {
    return executeJsonPostMethod('/statistic/test', sendingData).then((resp) => {
        return Promise.resolve(resp.data.content)
    })
}

/**
 * Сохранение статистики по карточкам
 * @param {object} sendingData - объект статистики
 * @method saveUserTestStatistic
 * @return {Response} Fetch Response
 */
export function saveUserCardStatistic(sendingData: any) {
    return executeJsonPostMethod('/statistic/card', sendingData).then((resp) => {
        return Promise.resolve(resp.data.content)
    })
}

/**
 * Сохранение статистики fill-gaps
 * @param {object} sendingData - объект статистики
 * @method saveUserFillGapsStatistic
 * @return {Response} Fetch Response
 */
export function saveUserFillGapsStatistic(sendingData: any) {
    return executeJsonPostMethod('/statistic/fill-gaps', sendingData).then((resp) => {
        return Promise.resolve(resp.data.content)
    })
}

/**
 * Сохранение статистики по филвордам
 * @param {object} sendingData - объект статистики
 * @method saveUserFillWordStatistic
 * @return {Response} Fetch Response
 */
export function saveUserFillWordStatistic(sendingData: any) {
    return executePostMethod('/statistic/fill-word', sendingData)
}

/**
 * Получение статискики по неправильным ответам
 * @method getMistakesStatistic
 * @return {Response} Fetch Response
 */
export function getMistakesStatistic() {
    return executeJsonGetMethod('/rating/user/words/mistakes').then((resp) => {
        return Promise.resolve(resp.data.content)
    })
}

/**
 * Получение статискики по не повторенным спискам слов
 * @method getWordListStatistic
 * @return {Response} Fetch Response
 */
export function getWordListStatistic() {
    return executeJsonGetMethod('/statistic/word-lists').then((resp) => {
        return Promise.resolve(resp.data)
    })
}

/**
 * Получение статистики для отрисовки графика
 * @method getGraphStatistic
 * @return {Response} Fetch Response
 */
export function getGraphStatistic() {
    return executeJsonGetMethod('/statistic/graph').then((resp) => {
        return Promise.resolve(resp.data.content)
    })
}

/**
 * Получение информации по словам для пользователя и пользователя по userId
 * @method getWordsStatisticByUserId
 * @return {Response} Fetch Response
 */
export function getWordsStatisticByUserId(userId: number) {
    return executeJsonGetMethod('/statistic/words/' + userId).then((resp) => {
        return Promise.resolve(resp.data)
    })
}

/**
 * Обновление статистики нового пользователя
 * @method updateNewCommerceStatistic
 * @return {Response} Fetch Response
 */
export function updateNewCommerceStatistic(page: string) {
    return executePutMethod('/statistic/pages/' + page)
}

/**
 * Получение сегодняшней статистики
 * @method updateNewCommerceStatistic
 * @return {Response} Fetch Response
 */
export function getTodayStatistic() {
    return executeJsonGetMethod('/statistic/words/today')
}

/**
 * Получение сегодняшней статистики за неделю
 * @method updateNewCommerceStatistic
 * @return {Response} Fetch Response
 */
export function getWordsWeekChartStatistic() {
    return executeJsonGetMethod('/statistic/words/week/chart')
}


/**
 * Получение статистики выученных слов
 * @method getWordsWeekChartStatistic
 * @return {Response} Fetch Response
 */
export function getMasteredWordCount() {
    return executeJsonGetMethod('/statistic/words/mastered')
}
